import { render, staticRenderFns } from "./AddRemoteArea.vue?vue&type=template&id=d0a2db1a&lang=pug&"
import script from "./AddRemoteArea.vue?vue&type=script&lang=js&"
export * from "./AddRemoteArea.vue?vue&type=script&lang=js&"
import style0 from "./AddRemoteArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports